export default __webpack_public_path__ + "static/media/client-sdk-icon.a588f641.svg";